import { render } from "./HoraShow.vue?vue&type=template&id=874f613e"
import script from "./HoraShow.vue?vue&type=script&lang=js"
export * from "./HoraShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__